const translations = {
  "en": {
    "Edgen App": "Ed App",
    "Scan to Download": "Scan to Download"
  },
  "zh-tw": {
    "Edgen App": "Ed 應用程式",
    "Scan to Download": "掃描下載"
  }
};

export default translations;
